// FORGED Ed Systems — DEPLOY001 — v0.1.0 — supabaseClient.ts
// Last touched: 2026-05-19
//
// Browser-side Supabase client. Uses the anon key only — RLS enforces
// per-account access at the database layer. Service-role key is server-only
// and never reaches the browser.

import { createClient } from "@supabase/supabase-js";

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL as string;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY as string;

if (!supabaseUrl || !supabaseAnonKey) {
  // eslint-disable-next-line no-console
  console.error(
    "Missing VITE_SUPABASE_URL or VITE_SUPABASE_ANON_KEY env vars. " +
      "Set them in Netlify site settings before deploy."
  );
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
  },
});
